import React from "react";
import Navbar from "./SpeakerComponents/Navbar";
import Landing from "./SpeakerComponents/Landing";
import Product from "./SpeakerComponents/Product";
import Contact from "./LandingComponents/Contact/Contact";
import Footer from "./SpeakerComponents/Footer";
import About from "./SpeakerComponents/About";


const SpeakerPage = ({ setCurrentPage }) => {
  return (
    <>
      <Navbar setCurrentPage={setCurrentPage}/>
      <Landing />
      <About />
      <Product />
      <Contact />
      <Footer />
    </>
  );
};

export default SpeakerPage;
